import React, { useContext, useEffect, useState } from "react";
import { IdentityContext } from "../IdentityContext";
import { ProjectContext } from "../ProjectContext";
import { Navbar, Nav } from "react-bootstrap";
import { useTheme } from "../Theme/ThemeContext";
import styled, { withTheme } from "styled-components";
import { StyledNavItem, StyledNavBar, StyledUserIcon } from "../Theme/Theme";
import { Route, useParams, NavLink, useLocation } from "react-router-dom";
import queryString from "query-string";
// Styles
import "./HeaderNav.scss";

// Assets
import logo from "./ph-logo.png";

function determinePubHubBaseUrl() {
  const hostname = window.location.hostname;
  if (/localhost/.test(hostname)) {
    return "http://localhost:3000";
    // return "https://dev.pubhub.studio";
  } else if (/admin-dev/.test(hostname)) {
    return "https://dev.pubhub.studio";
  } else if (/admin-test/.test(hostname)) {
    return "https://test.pubhub.studio";
  } else if (/admin-prep/.test(hostname)) {
    return "https://prep.pubhub.studio";
  } else if (/admin./.test(hostname)) {
    return "https://pubhub.studio";
  }
}

function HeaderNav(props) {
  let location = useLocation();
  const { authUser } = useContext(IdentityContext);
  const { project } = useContext(ProjectContext);

  useEffect(() => {
    if (window.posthog) {
      window.posthog.capture('$pageview');
    }
  }, [location]);

  useEffect(() => {
    if (window.posthog) {
      if (authUser && typeof authUser === 'object') {
        window.posthog.identify(authUser._id, {
          username: authUser.username
        });
        // Set email or any other data
        window.posthog.people.set({
          email: authUser.email
        });
        window.posthog.people.set({
          username: authUser.username
        });
      }
    }
  }, [authUser]);

  const themeToggle = useTheme();
  const landingPath = window.location.pathname;
  const projectId = landingPath.split("/")[2];
  const groupsPath = "/groups/" + projectId;
  const campaignsPath = "/campaigns/" + projectId;
  const workflowsPath = "/workflows/" + projectId;
  const usersPath = "/users/" + projectId;
  const configurationPath = "/settings/" + projectId;
  const teamPath = "/team/" + projectId;
  const sitePath = "/sites/" + projectId;

  let user = {
    displayName: "displayName",
  };

  const isActive = (match, location) => {
    if (!match) {
      return false;
    }

    // only consider an event active if its event id is an odd number
    const eventID = parseInt(match.params.eventID);
    return !isNaN(eventID) && eventID % 2 === 1;
  };

  /*
    Project User Permissions
    PH USER ROLES
    isCurrentUserOwner
      ph user role: sysadmin
      ph user created LC
      team role: admin
    isCurrentUserAdmin
      team role: admin
    isCurrentPageAdmin
      team role: page admin
    isCurrentPageDeveloper
      team role: page dev
    isCurrentContentCreator
      team role: content creator
    isWorkflowManager
    isWorkflowUser

    LC show/hide
    workflows = project.config.enableWorkflows
    campaigns = project.config.disableCampaigns
    (publication/library: leaderboards = setting.config.disableLeaderboards)
  */

  return (
    <>
      <StyledNavBar collapseOnSelect expand="sm" fixed="top">
        <Navbar.Brand>
          <a
            style={{ cursor: "pointer" }}
            onClick={() =>
              (window.location.href = `${determinePubHubBaseUrl()}/learningcentres/${projectId}`)
            }
          >
            <img src={logo} alt="PubHub Admin" width="40rem" />
          </a>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        { project &&
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              {
                (project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) && project?.config?.showTX ?
                  <StyledNavItem as={NavLink} to={sitePath}>Sites</StyledNavItem> : <></>
              }
              {
                (project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) ?
                  <StyledNavItem as={NavLink} to={configurationPath}>Settings</StyledNavItem> : <></>
              }
              {
                (project?.userPermissions?.isWorkflowManager || project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) ?
                  <StyledNavItem as={NavLink} to={teamPath}>Team</StyledNavItem> : <></>
              }
              {
                (project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin || project?.userPermissions?.isWorkflowManager) ?
                  <StyledNavItem as={NavLink} to={usersPath}>Users</StyledNavItem> : <></>
              }
              {
                (project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) ?
                  <StyledNavItem as={NavLink} to={groupsPath}>Groups</StyledNavItem> : <></>
              }
              {
                !project?.config?.disableCampaigns && (project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) && !project?.config?.hidePH ?
                  <StyledNavItem as={NavLink} to={campaignsPath}>Campaigns</StyledNavItem> : <></>
              }
              {
                (project?.config?.enableWorkflows || project?.config?.showTX) && (project?.userPermissions?.isWorkflowManager || project?.userPermissions?.isWorkflowUser || project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) ?
                  <StyledNavItem as={NavLink} to={workflowsPath}>Workflows</StyledNavItem> : <></>
              }
              {/* <StyledNavItem as={NavLink} to="/reports">Reports</StyledNavItem> */}
            </Nav>
            <Nav>
              {/*Removing the switch for dark mode until implemented*/}
              {/*<StyledNavItem*/}
              {/*  to=""*/}
              {/*  onClick={(e) => {*/}
              {/*    e.preventDefault();*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <span*/}
              {/*    style={{ cursor: "pointer" }}*/}
              {/*    onClick={() => themeToggle.toggle()}*/}
              {/*  >*/}
              {/*    {props.theme.mode === "dark"*/}
              {/*      ? "Switch to Light Mode"*/}
              {/*      : "Switch to Dark Mode"}*/}
              {/*  </span>*/}
              {/*</StyledNavItem>*/}

              <StyledNavItem
                to=""
                onClick={(e) => {
                  e.preventDefault();
                }}
                className="user-display-name"
              >
                {authUser ? authUser.displayName : ''}
              </StyledNavItem>
            </Nav>
          </Navbar.Collapse>
        }
      </StyledNavBar>
    </>
  );
}

export default withTheme(HeaderNav);
